exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".device-card-grid-7L3D4L8umwr{width:100%}.device-card-name-ZwJPlljsmwr{}.device-card-img-2K85VkPBmwr{box-sizing:border-box}.device-card-data-1TqxjnHDmwr{display:flex;flex:0 1 auto;flex-direction:column;overflow:hidden}.device-card-small-iPAuba6tmwr{font-size:12px;flex-wrap:nowrap}.device-card-small-iPAuba6tmwr .device-card-img-2K85VkPBmwr{flex:0 0 28px}.device-card-medium-5dhUG7qymwr{font-size:12px}.device-card-medium-5dhUG7qymwr .device-card-name-ZwJPlljsmwr{font-size:14px}.device-card-medium-5dhUG7qymwr .device-card-img-2K85VkPBmwr{flex:0 0 38px}.device-card-large-Lg4pBjkYmwr{font-size:14px}.device-card-large-Lg4pBjkYmwr .device-card-name-ZwJPlljsmwr{font-size:16px}.device-card-large-Lg4pBjkYmwr .device-card-img-2K85VkPBmwr{flex:0 0 53px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"grid": "device-card-grid-7L3D4L8umwr",
	"name": "device-card-name-ZwJPlljsmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["ellipsize"] + "",
	"img": "device-card-img-2K85VkPBmwr",
	"data": "device-card-data-1TqxjnHDmwr",
	"small": "device-card-small-iPAuba6tmwr",
	"medium": "device-card-medium-5dhUG7qymwr",
	"large": "device-card-large-Lg4pBjkYmwr"
};